import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'           // i18n must be imported before App
import App from './App.tsx'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/ru'

// Extend dayjs globally — every component can call .tz() after this
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

async function bootstrap() {
  // `npm run dev:mock` — serve the whole app from in-memory fixtures, no backend needed.
  // VITE_MOCK is inlined at build time, so production drops this branch entirely.
  if (import.meta.env.VITE_MOCK === '1') {
    await import('./mocks/install')
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

bootstrap()
